import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { AdminsAvatarsComponent, type AvatarUser } from '@core/account-ui';
import { assigneeToAvatarUser } from '@core/ask-hr-smart-ui';
import { priorityColorMap } from '@core/ask-hr-templates-util';
import type { AskTicketBoardItem } from '@core/ask-hr-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { SymbolComponent } from '@core/symbol-legacy';
import { TimeAgoPipe } from '@core/time-legacy';
import {
  DividerComponent,
  HeadingComponent,
  IconComponent,
  type IconToken,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'ask-ticket-item',
  imports: [
    HeadingComponent,
    DividerComponent,
    AdminsAvatarsComponent,
    SymbolComponent,
    IconComponent,
    TimeAgoPipe,
    TranslatePipe,
    MomentModule,
    RtTooltip,
  ],
  templateUrl: './ask-ticket-item.component.html',
  styleUrl: './ask-ticket-item.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card rt-card-clickable',
  },
})
export class AskTicketItemComponent {
  protected readonly priorityColorMap: Record<
    Exclude<AskTicketBoardItem['priority'], null>,
    IconToken
  > = priorityColorMap;

  public ticket = input.required<AskTicketBoardItem>();
  public redirectUrl = input<string | null>(null);

  protected assignees = computed((): AvatarUser[] =>
    this.ticket().assignees.map(assignee => assigneeToAvatarUser(assignee)),
  );
  protected requesterName = computed(() => {
    const { requester } = this.ticket();
    return `${requester.firstName} ${requester.lastName}`;
  });
}
